<div class="dim-background"></div>
<div class="toolbox-component" id="product-chooser">
  <div class="header">
    <div class="header-title">
      <span class="header-title-main">
        {{ 'i18n.toolbox.productChooser.title' | translate }}
      </span>
    </div>
    <mat-icon svgIcon="close"
      class="close-x"
    (click)="btnCloseClick()"></mat-icon>
  </div>
  <div class="content">
    <div class="content-message">
      <div class="main-message">
        {{ 'i18n.toolbox.productChooser.contentMessage.one' | translate }}
      </div>
      <div class="sub-message">
        {{ 'i18n.toolbox.productChooser.contentMessage.two' | translate }}
      </div>
    </div>
    <product-chooser #productChooser></product-chooser>
  </div>
</div>
